export const DropShipInput = {
  NO: '1',
  YES: '2',
} as const
